import { useState, useEffect } from "react";
import { Shield, Menu, X, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";

const NAV = [
  { label: "Le programme", href: "#timeline" },
  { label: "Automatisation", href: "#automation" },
  { label: "Avantages", href: "#benefits" },
  { label: "Simulateur", href: "#simulator" },
  { label: "FAQ", href: "#faq" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-black/70 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5" data-testid="brand-logo">
          <Shield className="h-7 w-7 text-norton-yellow shrink-0" strokeWidth={2.5} />
          <span className="leading-tight">
            <span className="block text-base sm:text-lg font-heading font-bold tracking-tight">
              Antivirus<span className="text-norton-yellow">Edition</span>.com
            </span>
            <span className="block text-[10px] sm:text-xs text-zinc-400 font-body tracking-wide">
              votre distributeur Norton
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.href.replace("#", "")}`}
              className="text-sm text-zinc-400 hover:text-white transition-colors duration-200"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Button
            asChild
            data-testid="header-cta-button"
            className="bg-norton-yellow text-black hover:bg-norton-yellow-hover rounded-full font-semibold px-6"
          >
            <a href="mailto:contact@antivirusedition.com">
              <Mail className="mr-2 h-4 w-4" />
              contact@antivirusedition.com
            </a>
          </Button>
        </div>

        <button
          className="lg:hidden text-white"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden backdrop-blur-xl bg-black/90 border-b border-white/10 px-6 py-6 flex flex-col gap-5" data-testid="mobile-menu">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={() => setOpen(false)}
              className="text-base text-zinc-300 hover:text-norton-yellow transition-colors"
            >
              {n.label}
            </a>
          ))}
          <Button
            asChild
            className="bg-norton-yellow text-black hover:bg-norton-yellow-hover rounded-full font-semibold mt-2"
          >
            <a href="mailto:contact@antivirusedition.com" onClick={() => setOpen(false)}>
              <Mail className="mr-2 h-4 w-4" />
              contact@antivirusedition.com
            </a>
          </Button>
        </div>
      )}
    </header>
  );
}
